import { Entry } from '../Entry'

export function Entry20260624() {
  return (
    <Entry title="2026 Jun 24 - v3.11.13">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/25877/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
